module.exports = __webpack_public_path__ + "static/media/paint-brush-alt.b71e744d.svg";